import { Service } from '@angular/core';
import { Subject } from 'rxjs';

@Service()
export class SectionStateService {
  private expandSection = new Subject<string>();
  expandSection$ = this.expandSection.asObservable();

  requestSectionExpand(sectionId: string) {
    this.expandSection.next(sectionId);
  }
}
